import axios from "axios";

export default function PurchaseorderOfferUploadService(file) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/uploadOfferTemplate",
    data: file,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
